<div id="checkout" class="bg-gray-100 p-4 h-full overflow-y-auto">
  <button
    data-cy="back-to-seat-selection-button"
    class="hidden top-5 max-[1800px]:z-20 sticky md:flex items-center self-start bg-white max-[1800px]:shadow-xl my-5 px-4 py-2 rounded-xl font-bold text-gray-900 hover:scale-95 transition-transform"
    (click)="restartTransaction()">
    <svg
      class="mr-2 w-5 h-5"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg">
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M15 19l-7-7 7-7"></path>
    </svg>
    Back
  </button>
  <div class="mx-auto max-w-7xl container">
    <div class="relative flex flex-col justify-start mb-7 md:mb-5 text-center">
      <h1 class="self-start mb-1 md:mb-3 lg:mb-0 text-4xl">Your cart</h1>
    </div>
  </div>
  <div
    class="gap-4 grid grid-cols-1 md:grid-cols-2 mx-auto mb-10 w-full max-w-7xl"
    [ngClass]="{
      'md:grid-rows-2': configurationService.configuration.upsells,
      'md:grid-rows-1': configurationService.configuration.upsells,
    }">
    @if (
      configurationService.configuration.upsells &&
      transaction()?.transaction?.event?.upsells?.length
    ) {
      <div class="w-full max-w-2xl max-h-fit">
        <app-group-outing
          class="flex rounded-2xl h-full max-h-fit"
          [transaction]="transaction()!"
          [upsellSelected]="upsellSelected"
          [totalTransactionSeats]="totalTransactionSeats"
          [discountActive]="isDiscountActive"
          (changeUpsell)="onChangeUpsell($event)" />
      </div>
      <div
        class="top-10 left-0 md:sticky self-start order-2 md:order-1 row-span-2 md:-mt-9">
        <div class="mb-4 w-full max-w-2xl">
          <app-timer
            (transactionExpired)="onTransactionExpired()"
            [createdTime]="transaction()!.transaction.createdAt"></app-timer>
        </div>
        <div class="mb-4 w-full max-w-2xl">
          <app-summary
            [summaryText]="configurationService.configuration.cartSummaryText"
            [transaction]="transaction()!"
            [totalTransactionSeats]="totalTransactionSeats"
            [upsellSelected]="upsellSelected"
            [rainoutValue]="rainoutValue"
            [isTicketFeeEnabled]="isTicketFeeEnabled()"
            [isDiscountCodesEnabled]="isDiscountCodesEnabled()" />
        </div>
        @if (!demoDataService.isDemoActive() && isDiscountCodesEnabled()) {
          <div class="mb-4 w-full max-w-2xl">
            <app-discount-code
              [transaction]="transaction()!"
              [disabled]="isSelectedUpsellNotEditable"
              (transactionChange)="onDiscountCodeChange($event)" />
          </div>
        }
        @if (isRainout) {
          <div class="w-full max-w-2xl">
            <app-rainout-info
              [transaction]="transaction()!"
              [totalTransactionSeats]="seats.length"
              [upsellSelected]="upsellSelected"
              (changeUpsell)="onChangeUpsell($event)"
              (rainoutChange)="onRainoutChange($event)" />
          </div>
        }
        <div class="w-full max-w-2xl">
          <button
            data-cy="go-to-payment-button"
            class="bg-gray-900 disabled:bg-gray-600 disabled:opacity-30 ml-auto disabled:hover:transform-none hover:scale-95 transition-transform btn-black"
            (click)="proceedToPayment()"
            [disabled]="
              configurationService.configuration.rainout &&
              rainoutValue === null &&
              eventDate - nowDate > deadlineInMilliseconds
            "
            [tooltip]="
              configurationService.configuration.rainout &&
              rainoutValue === null &&
              eventDate - nowDate > deadlineInMilliseconds
                ? 'Please select a Rainout Insurance option.'
                : ''
            "
            placement="top"
            triggers="pointerenter:pointerout">
            Proceed to Payment
            <span class="ml-4 pointer-events-none"
              ><img
                ngSrc="/assets/img/arrow-right-white-icon.svg"
                width="8"
                height="14"
                [priority]="false"
                alt="Arrow right icon"
            /></span>
          </button>
        </div>
      </div>
      <div class="order-1 md:order-2 w-full max-w-2xl">
        <app-cart class="flex h-full" [transaction]="transaction()!" />
      </div>
    } @else {
      <div class="md:sticky self-start order-2 row-span-2 md:-mt-9">
        <div class="mb-4 w-full max-w-2xl">
          <app-timer
            (transactionExpired)="onTransactionExpired()"
            [createdTime]="transaction()!.transaction.createdAt"></app-timer>
        </div>
        <div class="mb-4 w-full max-w-2xl">
          <app-summary
            [summaryText]="configurationService.configuration.cartSummaryText"
            [transaction]="transaction()!"
            [totalTransactionSeats]="totalTransactionSeats"
            [upsellSelected]="upsellSelected"
            [rainoutValue]="rainoutValue"
            [isTicketFeeEnabled]="isTicketFeeEnabled()"
            [isDiscountCodesEnabled]="isDiscountCodesEnabled()" />
        </div>
        @if (!demoDataService.isDemoActive() && isDiscountCodesEnabled()) {
          <div class="mb-4 w-full max-w-2xl">
            <app-discount-code
              [transaction]="transaction()!"
              [disabled]="isSelectedUpsellNotEditable"
              (transactionChange)="onDiscountCodeChange($event)" />
          </div>
        }
        @if (isRainout) {
          <div class="w-full max-w-2xl">
            <app-rainout-info
              [transaction]="transaction()!"
              [totalTransactionSeats]="seats.length"
              [upsellSelected]="upsellSelected"
              (changeUpsell)="onChangeUpsell($event)"
              (rainoutChange)="onRainoutChange($event)" />
          </div>
        }
        <div class="w-full max-w-2xl">
          <button
            data-cy="go-to-payment-button"
            class="bg-gray-900 disabled:bg-gray-600 disabled:opacity-30 ml-auto disabled:hover:transform-none hover:scale-95 transition-transform btn-black"
            (click)="proceedToPayment()"
            [disabled]="
              configurationService.configuration.rainout &&
              rainoutValue === null &&
              eventDate - nowDate > deadlineInMilliseconds
            "
            [tooltip]="
              configurationService.configuration.rainout &&
              rainoutValue === null &&
              eventDate - nowDate > deadlineInMilliseconds
                ? 'Please select a Rainout Insurance option.'
                : ''
            "
            placement="top"
            triggers="pointerenter:pointerout">
            Proceed to Payment
            <span class="ml-4 pointer-events-none"
              ><img
                ngSrc="/assets/img/arrow-right-white-icon.svg"
                width="8"
                height="14"
                [priority]="false"
                alt="Arrow right icon"
            /></span>
          </button>
        </div>
      </div>
      <div class="w-full max-w-2xl">
        <app-cart class="flex h-full" [transaction]="transaction()!" />
      </div>
    }
  </div>
</div>
